import { render } from "./WbsRechner.vue?vue&type=template&id=6acfa8bb&scoped=true&ts=true"
import script from "./WbsRechner.vue?vue&type=script&lang=ts"
export * from "./WbsRechner.vue?vue&type=script&lang=ts"

import "./WbsRechner.vue?vue&type=style&index=0&id=6acfa8bb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6acfa8bb"]])

export default __exports__